export default __webpack_public_path__ + "static/media/profile02.6ea8c10a.jpg";